import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import store from 'root/admin/store';
import { useGetRecords } from 'root/admin/components/hooks';
import { CreateNew } from 'root/admin/components';

import { Table, Column, Loader, Image } from '@smartplatform/ui';

const AwardList = ({ rootPath, tabName }) => {
	const records = useGetRecords({ model: 'Award', tabName });

	if (!records) {
		return <Loader />;
	}

	console.log(rootPath);
	return (
		<div>
			<CreateNew link={`${rootPath}/awards/new`} name="Новая Награда" />
			<Table records={records} rootPath={rootPath}>
				<Column property="name" label="Название" />
				<Column property="thumbnail" label="Миниатюра">
					<Image />
				</Column>
			</Table>
		</div>
	);
};

export default AwardList;
